import { useEffect, useState } from "react";

export const useModal = (isOpen: boolean, duration = 300) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);

      setTimeout(() => {
        setIsVisible(true);
      }, 10);

    } else {
      setIsVisible(false);

      const timeout = setTimeout(() => {
        setShouldRender(false);
      }, duration);

      return () => clearTimeout(timeout);
    }
  }, [isOpen, duration]);

  return { shouldRender, isVisible };
};